import React from 'react';

import { ProtectorType } from 'core/constants';
import { EnumOptions } from 'utils/api/modules/entities/entities.types';
import { YES_NO_NA_SOLID_TONE } from 'components/Audits/choiceTone';

import EntitiesInlineChoiceField from '../EntitiesInlineChoiceField';

export type EntitiesYesNoNaFieldProps = {
  value: string[];
  items: EnumOptions;
  onChange: (value: string[]) => void;
  requiredNotFilled?: boolean;
  errorMessage?: string;
  description?: string;
};

const EntitiesYesNoNaField = ({
  value,
  items,
  onChange,
  requiredNotFilled,
  errorMessage,
  description,
}: EntitiesYesNoNaFieldProps): React.ReactElement => (
  <EntitiesInlineChoiceField
    type={ProtectorType.SingleChoice}
    value={value}
    items={items}
    onChange={onChange}
    requiredNotFilled={requiredNotFilled}
    errorMessage={errorMessage}
    description={description}
    optionTone={YES_NO_NA_SOLID_TONE}
  />
);

export default EntitiesYesNoNaField;
